import type { FaireProductEntity } from "../../entity_types/product";

export const p_a3h4rrxvk6: FaireProductEntity = {
  token: "p_a3h4rrxvk6",
  type: "product",
  name: "BOW CAKE - Sneaker Look, Slip Ons, Pearl Details",
  brandToken: "b_mz3xxxsvnf",
  brandName: "Lemonade Shoes",
  imageUrl:
    "https://cdn.faire.com/fastly/fe0a8c0e3e5675a1c218b6af657406e320826de57b4cab1f1a0ee0471d388869.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/efd0aa1f1b9b10f5c05e1da6172d6a4428161d7f0f763aa503f4bbf4de22d7cb.jpeg",
    "https://cdn.faire.com/fastly/c4675e0dbd54c3c89af679456a0984c55ce872ff766d530963910c49e21d224a.jpeg",
    "https://cdn.faire.com/fastly/469dd9866ff36130d1a03445b555a19121717876ef409d4a4b3db7bff57aa1d4.jpeg",
    "https://cdn.faire.com/fastly/47ab2df7fc631f332612b74aafb779899f5d1f422e371bfeecab42a6a89dcf72.jpeg",
  ],
  priceDollars: 15.75,
  description:
    "Cute meets comfort in these bow-accent sneakers, designed with oversized ribbon laces and pearl embellishments for a playful, feminine finish. The soft suede-inspired upper, lightweight sole, and cushioned fit make them perfect for everyday wear, while the pearl details add just the right amount of charm. Available in soft pink, beige, chocolate brown, and black.\n\nOOTD\nPair them with a pleated mini skirt and an oversized knit for an effortless balletcore look, or wear them with relaxed denim and a baby tee for a casual outfit with a girly twist. Finish with lace socks or frilly ankle socks to highlight the sweet bow and pearl details.",
  tags: [],
  msrpDollars: 31.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-13T23:39:09.365Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
